/* eslint-disable */
import React from "react";
import back_asset from "../../assets/01_Home/Icon_Left.svg";
import read_more_icon from "../../assets/hyundai-icono-ver-mas.svg";
import { Link } from "react-router-dom";

interface HeaderComponentProps {
  category: any;
  titleCategory: any
}

const HeaderComponent: React.FC<HeaderComponentProps> = ({ category, titleCategory }) => {
  return (
    <>
      <div className="header-normal-news">
        <Link to={`/noticias/${category}`} className="back">
          <img src={back_asset} alt="" />
          Regresar
        </Link>
        <div className="category">
            {titleCategory}
        </div>
      </div>
    </>
  );
};

export default HeaderComponent;
